import { useAuthStore } from '../stores/authStore'
import ParentStudentPortal from './dashboards/ParentStudentPortal'
import StudentPortal from './StudentPortal'

export default function Portal() {
  const role = useAuthStore(state => state.user?.user_type)
  return role === 'student' ? <StudentPortal/> : <ParentStudentPortal/>
}
